/**
 * Custom: Collection description
 * -----------------------------------------------------------------------------
 * Renders the collection description as rich text.
 *
 * `sections/main-collection.liquid` outputs the description as HTML, but the
 * compiled `main-collection` component replaces that markup on mount and prints
 * `collection.description` with `v-text`, so the tags show up as literal text.
 * This turns the escaped text back into HTML each time the component renders
 * the element.
 *
 * The description is a Liquid prop that never changes after mount, so Vue does
 * not patch the element again and overwrite the HTML set here. Mutation
 * observers run before the next paint, so the escaped text is never shown.
 */
(function() {
  'use strict'

  var SELECTOR = '.main-collection__description'

  /**
   * Upgrades descriptions that Vue printed as text. Liquid output already has
   * element children and descriptions without markup are left alone.
   */
  function render() {
    var elements = document.querySelectorAll(SELECTOR)

    for (var i = 0; i < elements.length; i++) {
      var element = elements[i]

      if (element.childElementCount === 0 && element.textContent.indexOf('<') !== -1) {
        element.innerHTML = element.textContent
      }
    }
  }

  render()

  new MutationObserver(render).observe(document.body, {
    characterData: true,
    childList: true,
    subtree: true,
  })
})()
